import { ToolChangeSource, ToolHistoryEntryKind } from '@reach/shared-types/tool-history';

export const TOOL_HISTORY_FIELD_LABELS = {
  display_name: 'Name',
  description: 'Description',
  execution_kind: 'Execution type',
  http_method: 'HTTP method',
  base_url: 'Base URL',
  path_template: 'Path',
  request_schema: 'Input schema',
  request_mapping: 'Request mapping',
  response_mapping: 'Response format',
  response_size_limit: 'Response size limit',
  auth_type: 'Authentication type',
  auth_config: 'Authentication settings',
  credentials: 'Credentials',
  variables: 'Variables',
  lookup_config: 'Lookup settings',
  settings_by_feature: 'Feature settings',
  status: 'Status',
  timeout_ms: 'Timeout',
  max_retries: 'Maximum retries',
  tags: 'Tags',
  scopes: 'Scopes',
} as const satisfies Record<string, string>;

export const getToolHistoryFieldLabel = (field: string): string => {
  if (Object.hasOwn(TOOL_HISTORY_FIELD_LABELS, field)) {
    return TOOL_HISTORY_FIELD_LABELS[field as keyof typeof TOOL_HISTORY_FIELD_LABELS];
  }
  return field.replaceAll('_', ' ');
};

export const TOOL_HISTORY_COPY = {
  title: 'History',
  initialEntries: {
    [ToolHistoryEntryKind.CREATED]: 'Created',
    [ToolHistoryEntryKind.BASELINE]: 'Existing setup',
  },
  description: 'Saved changes to this tool. Sensitive values are hidden.',
  loading: 'Loading history…',
  error: 'Unable to load history.',
  retry: 'Try again',
  empty: 'No changes recorded yet.',
  loadingMore: 'Loading…',
  older: 'Load older changes',
  userId: 'User ID',
  separator: ' · ',
  before: 'Before',
  after: 'After',
  unset: 'Not set',
  sources: {
    [ToolChangeSource.DASHBOARD]: 'Signed-in user',
    [ToolChangeSource.API]: 'API',
    [ToolChangeSource.SYSTEM]: 'System',
  },
} as const;
